<template>
  <div class="title-block">
    {{ $t("app.modals.disableJoinLink.subtitle") }}
  </div>
  <p class="under-text">
    {{ $t("app.modals.disableJoinLink.text") }}
  </p>
  <div class="btn-container">
    <Button class="secondary outline sm" :label="$t('app.modals.disableJoinLink.buttons.cancel')" @click="emits('close')" />
    <Button class="primary sm" :label="$t('app.modals.disableJoinLink.buttons.confirm')" :loading="state.btnIsLoading" @click="deactivateLink" />
  </div>
</template>

<script setup>
import { reactive } from "vue";

const emits = defineEmits(["close", "confirm"]);

const state = reactive({
  btnIsLoading: false,
});

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

async function deactivateLink() {
  state.btnIsLoading = true;

  emits("confirm");
}
</script>
